var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('ConfirmDeleteOverlayStyled', [_c('Modal', {
    attrs: {
      "errors": _vm.errors
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function fn() {
        return [_vm._v(" " + _vm._s(_vm.$t('titles.pleaseConfirm')) + " ")];
      },
      proxy: true
    }, {
      key: "main",
      fn: function fn() {
        return [_c('div', {
          domProps: {
            "innerHTML": _vm._s(_vm.confirmText)
          }
        })];
      },
      proxy: true
    }, {
      key: "footer",
      fn: function fn() {
        return [_c('ActionsStyled', [_c('ButtonSolidStyled', {
          attrs: {
            "disabled": _vm.isConfirming
          },
          on: {
            "click": function click($event) {
              return _vm.$emit('close');
            }
          }
        }, [_vm._v(" " + _vm._s(_vm.$t('actions.cancel')) + " ")]), _c('ButtonBorderedStyled', {
          attrs: {
            "disabled": _vm.isConfirming
          },
          on: {
            "click": _vm.confirm
          }
        }, [!_vm.isConfirming ? [_vm._v(" " + _vm._s(_vm.$t('actions.ok')) + " ")] : _c('LoadingDots')], 2)], 1)];
      },
      proxy: true
    }])
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }